import _ from 'lodash';

import Assignee from 'models/assignee';
import createModel, { prop } from './lib/create_model';
import RoutingItemType from 'models/routing_item_type';

const RoutingItem = createModel({
  modelName: 'RoutingItem',

  properties: {
    assignee: prop(Assignee).isRequired,
    assigneeWas: prop(Assignee),
    itemType: prop().oneOf(..._.values(RoutingItemType)).isRequired,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },

    overrideFromJs(fromJs) {
      return attrs => {
        // work around Supernova sending invalid Assignee (an empty object) for assigneeWas
        if (_.isEmpty(attrs.assigneeWas)) {
          attrs = _.omit(attrs, 'assigneeWas');
        }

        return fromJs(attrs);
      };
    },
  },
});

export default RoutingItem;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/routing_item.js